import {ScheduledTrainsComponent} from '../../custom/vrgroup/scheduled-trains/scheduled-trains.component';
import {NotificationComponent} from '../../components/notification/notification.component';
import {ManagementComponent} from '../../management/management.component';
import {TrainListComponent} from '../../custom/vrgroup/train-list/train-list.component';
import {LandingPageTile} from './home-tile.model';
import {ElementInfoComponent} from '../../element-info/element-info/element-info.component';
import {TodayComponent} from '../../today/today.component';
import { VivoListComponent } from '../../vivo/vivo-list/vivo-list.component';
import { VivoMaintenanceComponent } from '../../vivo/vivo-maintenance/vivo-maintenance.component';
import { AlarmListComponent } from '../../alarm/alarm-list/alarm-list.component';
import { ArrivingTrainsComponent } from '../../custom/vrgroup/arriving-trains/arriving-trains.component';
import { ReminderManagerComponent } from '../../reminder/reminder-manager/reminder-manager.component';
import { MeasurementsTableComponent } from '~app/measurements/measurements-table/measurements-table.component';


export const maxCols = 64;
export const maxRows = 40;

const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
const viewWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
const emInPixels = parseFloat(getComputedStyle(document.documentElement).fontSize);
const gridHeight = viewHeight - 2.8 * emInPixels;
const gridWidth = viewWidth - 6.1 * emInPixels;
const fixedColWidth = Math.floor(gridWidth / maxCols);
const fixedRowHeight = Math.floor(gridHeight / maxRows);

export const availableTiles: LandingPageTile[] = [
  new LandingPageTile({
    unread: [],
    x: maxCols - transferPixelsToCols(392),
    y: 0,
    cols: transferPixelsToCols(392),
    rows: 40,
    minItemCols: transferPixelsToCols(335),
    minItemRows: transferPixelsToRows(170),
    component: TodayComponent,
    showOnSidebar: true
  }),
  new LandingPageTile({
    unread: [],
    x: maxCols - transferPixelsToCols(510),
    y: 0,
    cols: transferPixelsToCols(510),
    rows: 40,
    minItemCols: transferPixelsToCols(500),
    minItemRows: 10,
    component: VivoListComponent,
    showOnSidebar: true
  }),
  new LandingPageTile({
    unread: [],
    x: 0,
    y: 0,
    cols: transferPixelsToCols(560),
    rows: transferPixelsToRows(470),
    minItemCols: transferPixelsToCols(520),
    minItemRows: transferPixelsToRows(380),
    component: ElementInfoComponent,
    availableOnLanding: false,
    showOnSidebar: false
  }),
  new LandingPageTile({
    unread: [],
    x: 0,
    y: transferPixelsToRows(470), // Same as TrainListComponent's "rows" property
    cols: transferPixelsToCols(450),
    rows: transferPixelsToRows(470),
    minItemCols: transferPixelsToCols(450),
    minItemRows: transferPixelsToRows(190),
    component: ScheduledTrainsComponent,
    availableOnLanding: true,
    showOnSidebar: true
  }),
  new LandingPageTile({
    unread: [],
    x: 0,
    y: 0,
    cols: transferPixelsToCols(450),
    rows: transferPixelsToRows(470),
    minItemCols: transferPixelsToCols(400),
    minItemRows: transferPixelsToRows(190),
    component: TrainListComponent,
    availableOnLanding: true,
    showOnSidebar: true
  }),
  new LandingPageTile({
    unread: [],
    x: 0,
    y: 0,
    cols: transferPixelsToCols(450),
    rows: transferPixelsToRows(430),
    minItemCols: transferPixelsToCols(450),
    minItemRows: transferPixelsToRows(190),
    component: ArrivingTrainsComponent,
    showOnSidebar: true
  }),
  new LandingPageTile({
    unread: [],
    x: 0,
    y: 0,
    cols: transferPixelsToCols(460),
    rows: transferPixelsToRows(430),
    minItemCols: transferPixelsToCols(400),
    minItemRows: transferPixelsToRows(250),
    component: NotificationComponent,
    availableOnLanding: true,
    showOnSidebar: true
  }),
  new LandingPageTile({
    unread: [],
    x: 0,
    y: 0,
    cols: transferPixelsToCols(670),
    rows: transferPixelsToRows(450),
    minItemCols: transferPixelsToCols(475),
    minItemRows: transferPixelsToRows(270),
    component: ManagementComponent,
    showOnSidebar: true
  }),
  new LandingPageTile({
    unread: [],
    x: 0,
    y: 0,
    cols: transferPixelsToCols(670),
    rows: transferPixelsToRows(450),
    minItemCols: transferPixelsToCols(475),
    minItemRows: transferPixelsToRows(270),
    component: VivoMaintenanceComponent,
    showOnSidebar: true
  }),
  new LandingPageTile({
    unread: [],
    x: 0,
    y: 0,
    cols: transferPixelsToCols(460),
    rows: transferPixelsToRows(430),
    minItemCols: transferPixelsToCols(460),
    minItemRows: transferPixelsToRows(320),
    component: AlarmListComponent,
    showOnSidebar: true
  }),
  new LandingPageTile({
    unread: [],
    x: 0,
    y: 0,
    cols: transferPixelsToCols(440),
    rows: transferPixelsToRows(430),
    minItemCols: transferPixelsToCols(440),
    minItemRows: transferPixelsToRows(340),
    component: ReminderManagerComponent,
    showOnSidebar: true
  }),
  new LandingPageTile({
    unread: [],
    x: 0,
    y: 0,
    cols: transferPixelsToCols(480),
    rows: transferPixelsToRows(704),
    minItemCols: transferPixelsToCols(480),
    minItemRows: transferPixelsToRows(300),
    component: MeasurementsTableComponent,
    showOnSidebar: true
  }),
];

function transferPixelsToRows(pixels: number) {
  return Math.floor(pixels / fixedRowHeight);
}

function transferPixelsToCols(pixels: number) {
  return Math.floor(pixels / fixedColWidth);
}
